<template>
    <div class="page-container">
        <div class="page-title">兑换商品明细</div>
        <div class="list">
            <div class="incentive-item" v-for="(item,index) in goodsList" :key="index">
                <div class="goods-info-block">
                    <img :src="item.picUrl" class="goods-pic">
                    <div class="goods-detail">
                        <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                        <div class="goods-sku">
                            <span>{{item.skuValue == 'xiang' ? '整箱(6瓶)' : '单瓶'}}</span>
                            <span>x{{item.number}}{{item.skuValue == 'xiang' ? '箱' : '瓶'}}</span>
                        </div>
                        <div class="caigou-price">采购价：¥{{item.price}}/瓶</div>
                    </div>
                </div>
                <div class="item-bottom">总价：¥{{item.totalPrice}}</div>
            </div>
        </div>
        <div class="page-title" style="margin-top:20px;">共使用推荐奖励金额 <span>(当前可用推荐奖励金额：¥{{amount}})</span></div>
        <div class="input-grp">
            <div class="input-box">{{checkedAmount}}</div>
            <span>元</span>
        </div>

        <div class="btn-normal" @click="confirmPasswd">确认兑换</div>

        <!-- 提示设置交易密码弹层 -->
        <van-dialog 
            v-model="showSetPass"
            :close-on-click-overlay=true
            title="系统提示"
            message='兑换前请先去设置您的交易密码'
            confirmButtonText='去设置'
            confirmButtonColor='#3088F5'
            @confirm="jumpPage('account-info')"
        >
        </van-dialog>
        <!-- 输入密码弹层 -->
        <van-overlay :show="showPasswordLayer">
            <div class="wrapper">
                <div class="layer-content-block" :class="{'wrapper-to-top':showKeyboard}">
                    <div class="content-title">请输入交易密码 <van-icon name="cross" class="btn-close" size="22" color="#d2d2d2" @click.stop="showPasswordLayer = false" /></div>
                    <div class="content-bottom">
                        <div class="pay-detial">使用推荐奖励</div>
                        <div class="price">
                            ¥ <span>{{checkedAmount}}</span>
                        </div>
                        <div class="account-info"><span>付款账户</span><span>推荐奖励账户</span></div>
                        <!-- 密码输入框 -->
                        <van-password-input
                        :value="password"
                        :focused="showKeyboard"
                        @focus="showKeyboard = true"
                        />
                        <div class="err-notice" v-show="passwordErrorMsg">{{passwordErrorMsg}}</div>
                        <div class="layer-btn-confirm" @click="confirmPasswd">确认兑换</div>
                    </div>
                </div>
            </div>
        </van-overlay>
        <!-- 数字键盘 -->
        <van-number-keyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
        />
    </div>
</template>
<script>
import { Toast,Overlay,Icon,PasswordInput,NumberKeyboard,Dialog } from 'vant'
import $http from '@/lib/request'
import config from '@/config'
import md5 from 'js-md5'
import { getLocalUserInfo,setLocalUserInfo } from '@/lib/util'

export default {
    data(){
        return {
            goodsList:[],
            amount:0,
            orderId:'',
            showPasswordLayer:false,
            password:'',
            showKeyboard:false,
            passwordErrorMsg:'',//密码错误提示信息
            checkedAmount:0,
            showSetPass:false,//展示提示设置交易密码弹层
            userInfo:{},
        }
    },
    components:{
        [Toast.name]:Toast,
        [Overlay.name]:Overlay,
        [Icon.name]:Icon,
        [PasswordInput.name]:PasswordInput,
        [NumberKeyboard.name]:NumberKeyboard,
        [Dialog.Component.name]:Dialog.Component
    },
    watch:{
        showPasswordLayer(val,oldVal){
            this.password='';
        }
    },
    activated(){
        this.goodsList=this.$store.state.currentDhGoodsInfo;
        this.amount=this.$route.params.amount;
        this.orderId=this.$route.params.orderId;
        this.checkedAmount=this.$route.params.checkedAmount;

        this.checkuData();
        let uInfo=getLocalUserInfo();
        if(uInfo){
            this.userInfo=uInfo;
        }
    },
    deactivated(){
        this.password='';
        this.showPasswordLayer=false;
        this.showKeyboard=false;
    },
    methods:{
        checkuData(){//获取最新用户信息
            $http({
                method:'post',
                url:config.api.checkUserData
            }).then(res=>{
                if(res.errno == 0){
                    this.userInfo=res.data;
                    setLocalUserInfo(res.data);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
        confirm(){
            $http({
                method:'post',
                data:{
                    orderId:this.orderId,
                    jyPassword:this.password
                },
                url:config.api.prevUseReferral
            }).then(res=>{
                if(res.errno == 0){

                }else{
                    Toast(res.errmsg);
                }
            })
        },
        confirmPasswd(){
            this.$router.push({
                name:'common-yzm',
                params:{
                    orderId:this.orderId,
                    amount:this.checkedAmount,
                    action:'duihuan'
                }
            });

        },
        jumpPage(name){
            this.$router.push({
                name:name
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
::v-deep .van-password-input{
    margin:0;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.wrapper-to-top{
    transform: translateY(-40%);
}
.layer-content-block {
    background-color: #fff;
    width:300px;
    border-radius: 8px;
    .content-title{
        height:50px;
        line-height: 50px;
        text-align: center;
        position: relative;
        color:#333;
        font-size: 18px;
        .btn-close{
            position: absolute;
            right:15px;
            top:50%;
            transform: translateY(-50%);
        }
    }
    .content-bottom{
        padding:20px 28px;
        .pay-detial{
            font-size: 13px;
            color:#333;
            line-height: 18px;
            text-align: center;
            margin-bottom: 5px;
        }
        .price{
            text-align: center;
            color:#333;
            font-size: 26px;
            font-weight: 500;
            font-family: PingFangSC-Medium, PingFang SC;
            margin-bottom: 20px;
            &>span{
                font-size: 36px;
            }
        }
        .account-info{
            border-top:1px solid #f0f0f0;
            padding-top: 15px;
            line-height: 18px;
            margin-bottom: 25px;
            @include flex-between();
            &>span{
                font-size: 13px;
                color:#333;
                &:last-child{
                    font-weight: 500;
                }
            }
        }
        .err-notice{
            margin-top: 10px;
            color:#E43D3D;
            font-size: 13px;
            line-height: 18px;
        }
        .layer-btn-confirm{
            height:40px;
            line-height: 40px;
            text-align: center;
            border-radius: 26px;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            color:#fff;
            font-size: 16px;
            margin-top: 25px;
        }
    }
}
.page-container{
    background: #f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
    padding:10px;
    padding-bottom: 60px;
    .page-title{
        margin: 10px 0;
        font-size: 16px;
        color:#333;
        line-height: 22px;
        &>span{
            font-size: 12px;
            color:#999;
        }
    }
    .list{
        .incentive-item{
            background:#fff;
            border-radius: 4px;
            padding:0 15px;
            margin-bottom: 10px;
            .goods-info-block{
                display: flex;
                justify-content: flex-start;
                padding:15px 0;
                .goods-pic{
                    width:80px;
                    height:80px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-detail{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width:calc(100% - 70px);
                    .goods-name{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color:#000;
                        line-height: 20px;
                        font-size: 14px;
                    }
                    .goods-sku{
                        @include flex-between();
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                    .caigou-price{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
            .item-bottom{
                text-align: right;
                color:#3088F5;
                font-size: 14px;
                line-height: 20px;
                padding-bottom: 15px;
            }
        }
    }
    .input-grp{
        @include flex-between();
        height:40px;
        line-height: 40px;
        padding:0 15px;
        background:#fff;
        border-radius: 4px;
        font-size: 14px;
        color:#333;
        &>input,.input-box{
            height:40px;
            padding:0;
            border:none;
            background:none;
        }
    }
    .btn-normal{
        width: 180px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        border-radius: 26px;
        color:#fff;
        font-size: 16px;
        position: fixed;
        bottom:20px;
        left:50%;
        transform: translateX(-50%);
        &.disabled{
            background:#dcdcdc;
            color:#999;
        }
    }
}
</style>